export const extractSvg = () => {
  const iconContainers = document.querySelectorAll('span.svg-icon');

  iconContainers.forEach(iconContainer => {
    // Get the parent element of the <span>
    const parentElement = iconContainer.parentElement;

    // Check if the span has the class "start"
    if (iconContainer.classList.contains('start')) {
      // Add the child element as the first child of the parent
      const childElement = iconContainer.firstChild;
      if (childElement) {
        parentElement.insertBefore(childElement.cloneNode(true), parentElement.firstChild);
      }
    } else {
      // Get the child element of the <span>
      const childElement = iconContainer.firstChild;

      parentElement.appendChild(childElement.cloneNode(true));
    }

    // Remove the <span> element itself
    parentElement.removeChild(iconContainer);
  });
};
